export class WorkshopConfigurationModel {
    public showCustomerJobs: boolean;
    public showWorkshopJobs: boolean;
    public showVerifiedJobs: boolean;
    public jobOrdering: string ; 
    
    [x: string]: any;
}